import React from 'react'
import { ContentRenderer } from '@components/renderer'
import { TypeComponentCtaButton, TypeVariationContainerAuthAndDeviceTypeCta } from '@lib/types'
import styles from './plan-cta.module.scss'

export interface PlanCtaProps {
  cta: TypeComponentCtaButton | TypeVariationContainerAuthAndDeviceTypeCta
}

export const PlanCta: React.FC<PlanCtaProps> = ({ cta }) => {
  return (
    <div className={styles.container}>
      <ContentRenderer structure={cta} />
    </div>
  )
}
